<template>
    <div class="adduser" style="min-height:85vh;overflow-x: hidden;position: relative;">
        <div style="display:flex">
            <div style="margin: 16px 0;display:flex">
                <a-breadcrumb style="margin-top:auto;margin-bottom:auto">
                    <a-breadcrumb-item style="font-size:30px;">Rooms</a-breadcrumb-item>
                    <!-- <a-breadcrumb-item>Bill</a-breadcrumb-item> -->
                </a-breadcrumb>
                <a-button style="margin-top:auto;margin-bottom:auto;margin-left:20px" type="primary">
                    <router-link to="/admin/addroom">
                    Add Room
                    </router-link>
                </a-button>
            </div>
        </div>
        <div v-if="isLoading" style="position: absolute;left: 50%;z-index: 3;margin-left:-50px;display: inline-flex;text-align: center;position: absolute;top:190px;border-radius: 4px;">
            <!-- <a-spin size="large" style="z-index: 1;"/> -->
            <LoadingBar />
        </div>
        
        <div style="position:relative">
          <div style="position:absolute;right:0;top:-60px;display:flex;">
            <a-input-search style="width:400px;margin-right:0px;margin-left:auto" v-model="roomSearchText" placeholder="" @search="onSearch">
              <a-button slot="enterButton">
                Search Room
              </a-button>
            </a-input-search>
          </div>
          <div style="position:absolute;right:0;top:-25px;display:flex;width:400px;">
            <a-select v-model="searchHotel" style="height:35px;margin-bottom:5px;width:300px;">
              <a-select-option v-for="_hotel in hotelList" :key="_hotel._id" :value="_hotel._id">
                <div style="display:flex">
                  <div style="margin-left:5px;margin-top:auto;margin-bottom:auto;overflow-wrap: break-word;white-space: break-spaces;">{{ _hotel.hotelname }}</div>
                </div>
              </a-select-option>
            </a-select>
            <a-button @click="onSearchByHotel">
              Search Room By Hotel
            </a-button>
          </div>
          <div style="display:flex">
              <a-tabs
                  :active-key="currentTab"
                  :tab-position="'top'"
                  @change="handleTabChange"
              >
                  <a-tab-pane key="all" tab="All">
                      <RoomsTableItem
                        :key="listState.all.pagination.pageSize"
                        :roomlist="listState.all.list"
                        :columns="columns"
                        :tableCellCount="listState.all.pagination.pageSize"
                        :pagination="listState.all.pagination"
                        :loading="isLoading && currentTab === 'all'"
                        :filterDate="listState.all.filters.date"
                        :filterSeoScore="listState.all.filters.seoScore"
                        :filterReadScore="listState.all.filters.readScore"
                        @listUpdate="() => listUpdate('all')"
                        @listFilter="filters => listFilter('all', filters)"
                        @listFilterCount="count => listFilterCount('all', count)"
                        @tableChange="payload => handleTableChange('all', payload)"
                      />
                  </a-tab-pane>
                  <a-tab-pane key="mine" tab="Mine" force-render>
                      <RoomsTableItem
                        :key="listState.mine.pagination.pageSize"
                        :roomlist="listState.mine.list"
                        :columns="columns"
                        :tableCellCount="listState.mine.pagination.pageSize"
                        :pagination="listState.mine.pagination"
                        :loading="isLoading && currentTab === 'mine'"
                        :filterDate="listState.mine.filters.date"
                        :filterSeoScore="listState.mine.filters.seoScore"
                        :filterReadScore="listState.mine.filters.readScore"
                        @listUpdate="() => listUpdate('mine')"
                        @listFilter="filters => listFilter('mine', filters)"
                        @listFilterCount="count => listFilterCount('mine', count)"
                        @tableChange="payload => handleTableChange('mine', payload)"
                      />
                  </a-tab-pane>
                  <a-tab-pane key="published" tab="Published">
                      <RoomsTableItem
                        :key="listState.published.pagination.pageSize"
                        :roomlist="listState.published.list"
                        :columns="columns"
                        :tableCellCount="listState.published.pagination.pageSize"
                        :pagination="listState.published.pagination"
                        :loading="isLoading && currentTab === 'published'"
                        :filterDate="listState.published.filters.date"
                        :filterSeoScore="listState.published.filters.seoScore"
                        :filterReadScore="listState.published.filters.readScore"
                        @listUpdate="() => listUpdate('published')"
                        @listFilter="filters => listFilter('published', filters)"
                        @listFilterCount="count => listFilterCount('published', count)"
                        @tableChange="payload => handleTableChange('published', payload)"
                      />
                  </a-tab-pane>
                  <a-tab-pane key="draft" tab="Draft">
                      <RoomsTableItem
                        :key="listState.draft.pagination.pageSize"
                        :roomlist="listState.draft.list"
                        :columns="columns"
                        :tableCellCount="listState.draft.pagination.pageSize"
                        :pagination="listState.draft.pagination"
                        :loading="isLoading && currentTab === 'draft'"
                        :filterDate="listState.draft.filters.date"
                        :filterSeoScore="listState.draft.filters.seoScore"
                        :filterReadScore="listState.draft.filters.readScore"
                        @listUpdate="() => listUpdate('draft')"
                        @listFilter="filters => listFilter('draft', filters)"
                        @listFilterCount="count => listFilterCount('draft', count)"
                        @tableChange="payload => handleTableChange('draft', payload)"
                      />
                  </a-tab-pane>
              </a-tabs>
          </div>
        </div>
    </div>
</template>
<script>
import RoomsTableItem from './TableItems/RoomsTableItem.vue'
import { api } from '../helpers/Helpers';
import LoadingBar from '@/components/LoadingBar.vue';

const columns = [
  {
    title: 'Name',
    dataIndex: 'roomname',
    sorter: true,
    key: 'roomname',
    scopedSlots: { customRender: 'roomname' },
  },
  // {
  //   title: 'Image',
  //   dataIndex: 'roomimage',
  //   key: 'roomimage',
  //   scopedSlots: { customRender: 'roomimage' },
  // },
  // {
  //   title: 'Base Price',
  //   dataIndex: 'baseprice',
  //   key: 'baseprice',
  // },
  {
    title: 'Hotel',
    key: 'hotelname',
    sorter: true,
    dataIndex: 'hotelname',
  },
  {
    title: 'Tags',
    key: 'roomtags',
    dataIndex: 'roomtags',
  },
  {
    title: 'Date',
    key: 'createdate',
    sorter: true,
    dataIndex: 'createdate',
    scopedSlots: { customRender: 'createdate' },
  },
  {
    title: 'Api Integrate',
    key: 'apiintegrate',
    dataIndex: 'apiintegrate',
    sorter: true,
    scopedSlots: { customRender: 'apiintegrate' },
  },
  {
    title: 'Type',
    key: 'type',
    dataIndex: 'type',
  },
  {
    title: 'Number',
    key: 'numberofroom',
    sorter: true,
    dataIndex: 'numberofroom',
  },
  {
    title: 'SEO Score',
    key: 'seoscore',
    dataIndex: 'seoscore',
  },
  {
    title: 'ReadScore',
    key: 'readscore',
    dataIndex: 'readscore',
  },
  {
    title: 'Action',
    key: 'action',
    scopedSlots: { customRender: 'action' },
  },
];

const defaultFilters = () => ({
  date: 'all',
  seoScore: 'all',
  readScore: 'all',
  hotelId: '0',
});

const createInitialState = () => ({
  list: [],
  pagination: {
    current: 1,
    pageSize: 10,
    total: 0,
  },
  searchTerm: '',
  sortField: undefined,
  sortOrder: undefined,
  filters: defaultFilters(),
});

const STATUS_PUBLISHED = 1;
const STATUS_DRAFT = 0;
const OWNER_ID_PLACEHOLDER = 'MineUserId';

export default {
  data() {
    return {
      columns,
      currentTab: 'all',
      listState: {
        all: createInitialState(),
        mine: createInitialState(),
        published: createInitialState(),
        draft: createInitialState(),
      },
      hotelList:[
        {
          _id:'0',
          hotelname:'All'
        }
      ],
      roomSearchText:"",
      isLoading : false,
      searchHotel:'0',
      currentExportData: [],
    };
  },
  components: {
    LoadingBar,
    RoomsTableItem
  },
  
  mounted(){
      this.getRooms('all');
      this.getHotels();
  },
  methods: {
    createExportData(list) {
      return list.map((room) => ({
        Name: room.roomname || '',
        Hotel: room.hotelname || '',
        Type: room.type || '',
        Rooms: room.numberofroom || '',
        Status: room.status,
      }));
    },
    mapRoomToRow(room, index) {
      const createdDate = room && room.createdate ? new Date(room.createdate) : '';
      return {
        ...room,
        id: room._id,
        key: room._id || index + 1,
        createdate: createdDate,
        hotelname: room.hotelname || '',
        numberofroom: room.numberofroom,
        seoscore: room.seoscore,
        readscore: room.readscore,
        apiintegrate: room.apiintegrate || false,
        comments: room.comments || 0,
      };
    },
    buildDateRange(dateValue) {
      if (!dateValue || dateValue === 'all') {
        return {};
      }

      const baseDate = new Date(dateValue);
      if (Number.isNaN(baseDate.getTime())) {
        return {};
      }

      const from = new Date(baseDate.getFullYear(), baseDate.getMonth(), 1);
      const to = new Date(baseDate.getFullYear(), baseDate.getMonth() + 1, 1);

      return {
        createdFrom: from.toISOString(),
        createdTo: to.toISOString(),
      };
    },
    getHotels:async function(){
      this.hotelList = [];
      this.hotelList.push({
        _id:'0',
        hotelname:'All'
      });

      const res = await api.getHotelsTotal();
      res.sort(function(a,b) {
        let aValue = a['hotelname'];
        let bValue = b['hotelname'];
        return (aValue > bValue) ? 1 : ((bValue > aValue) ? -1 : 0);
        } 
      );
      this.hotelList = this.hotelList.concat(res);
    },
    async getRooms(tabKey = this.currentTab){
        const state = this.listState[tabKey];
        if (!state) {
          return;
        }

        this.isLoading = true;

        const params = {
          page: state.pagination.current,
          limit: state.pagination.pageSize,
        };

        if (state.searchTerm) {
          params.search = state.searchTerm;
        }

        const { date, seoScore, readScore, hotelId } = state.filters || defaultFilters();
        const range = this.buildDateRange(date);
        if (range.createdFrom) {
          params.createdFrom = range.createdFrom;
        }
        if (range.createdTo) {
          params.createdTo = range.createdTo;
        }

        if (seoScore && seoScore !== 'all') {
          params.seoScore = seoScore;
        }
        if (readScore && readScore !== 'all') {
          params.readScore = readScore;
        }

        if (hotelId && hotelId !== '0') {
          params.hotelId = hotelId;
        }

        if (tabKey === 'published') {
          params.status = STATUS_PUBLISHED;
        }
        if (tabKey === 'draft') {
          params.status = STATUS_DRAFT;
        }
        if (tabKey === 'mine') {
          params.ownerId = OWNER_ID_PLACEHOLDER;
        }

        if (state.sortField) {
          params.sortField = state.sortField;
          params.sortOrder = state.sortOrder || 'descend';
        }

        try {
          const res = await api.getAdminRooms({ params });
          const rooms = res && Array.isArray(res.rooms) ? res.rooms : [];
          const mappedRooms = rooms.map((room, index) => this.mapRoomToRow(room, index));

          state.list = mappedRooms;
          state.pagination.total = typeof res.total === 'number' ? res.total : rooms.length;
          state.pagination.current = res && res.page ? res.page : state.pagination.current;
          state.pagination.pageSize = res && res.limit ? res.limit : state.pagination.pageSize;

          if (tabKey === this.currentTab) {
            this.currentExportData = this.createExportData(mappedRooms);
          }
        } catch (error) {
          console.error('Error fetching rooms:', error);
        } finally {
          this.isLoading = false;
        }
    },
    onSearch() {
      const state = this.listState[this.currentTab];
      if (!state) {
        return;
      }
      state.searchTerm = this.roomSearchText.trim();
      state.pagination.current = 1;
      this.getRooms(this.currentTab);
    },
    onSearchByHotel() {
      const state = this.listState[this.currentTab];
      if (!state) {
        return;
      }
      state.filters = {
        ...state.filters,
        hotelId: this.searchHotel,
      };
      state.pagination.current = 1;
      this.getRooms(this.currentTab);
    },
    listUpdate(tabKey){
       this.getRooms(tabKey);
    },
    listFilterCount(tabKey, count){
      const state = this.listState[tabKey];
      if (!state) {
        return;
      }
      state.pagination.pageSize = count;
      state.pagination.current = 1;
      this.getRooms(tabKey);
    },
    listFilter(tabKey, filters){
      const state = this.listState[tabKey];
      if (!state) {
        return;
      }
      state.filters = {
        ...state.filters,
        ...filters,
      };
      state.pagination.current = 1;
      if (tabKey === this.currentTab) {
        this.roomSearchText = state.searchTerm;
      }
      this.getRooms(tabKey);
    },
    handleTableChange(tabKey, { pagination, sorter }) {
      const state = this.listState[tabKey];
      if (!state) {
        return;
      }

      if (pagination) {
        if (pagination.current) {
          state.pagination.current = pagination.current;
        }
        if (pagination.pageSize && pagination.pageSize !== state.pagination.pageSize) {
          state.pagination.pageSize = pagination.pageSize;
        }
      }

      if (sorter) {
        if (sorter.order && sorter.field) {
          state.sortField = sorter.field;
          state.sortOrder = sorter.order;
        } else {
          state.sortField = undefined;
          state.sortOrder = undefined;
        }
      }

      this.getRooms(tabKey);
    },
    handleTabChange(key) {
      this.currentTab = key;
      const state = this.listState[key];
      if (state) {
        this.roomSearchText = state.searchTerm || '';
        this.searchHotel = state.filters && state.filters.hotelId ? state.filters.hotelId : '0';
        if (!state.list.length) {
          this.getRooms(key);
        }
      }
    },
  }
}
</script>